export function getDateTime(timestamp = 0) {
    const dateObj = new Date(timestamp);

    const [d, m, y, h, i, s] = [
        dateObj.getDate().toString().padStart(2, "0"),
        (dateObj.getMonth() + 1).toString().padStart(2, "0"),
        dateObj.getFullYear().toString().padStart(4, "0"),
        dateObj.getHours().toString().padStart(2, "0"),
        dateObj.getMinutes().toString().padStart(2, "0"),
        dateObj.getSeconds().toString().padStart(2, "0")
    ];

    return `${d}/${m}/${y} ${h}:${i}:${s}`;
}  

export function formateDateTimeString(str) {
    const [date, time] = str.split(" ");
    const [yyyy, mm, dd] = date.split("-");
    const [h, min] = time.split(":");

    return `${dd}/${mm}/${yyyy} - ${h}:${min}`;
}

export function getTimestamp(dateFromApi = "/Date(0-0300)/") {
    return parseInt(dateFromApi.split("-")[0].replace(/\D/g, ""))
}


// WEBPACK FOOTER //
// ./src/rifa/utils/getDateTime.js